'use client';

import styles from '@/components/subscription/Commerce.module.css';
import { CircleDollarSign } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function LoginRewardBanner() {
  const t = useTranslations('welcomeReward');
  return (
    <div data-login-reward className={`${styles.surface} mt-5 flex items-center justify-between gap-3 rounded-2xl border border-[#D9E0E3] bg-[#EDF8FC] px-5 py-5 text-[#203644]`}>
      <div>
        <p className="text-sm font-semibold">{t('loginOffer')}</p>
        <p className="mt-1 flex flex-wrap items-baseline gap-x-2"><strong className="text-[44px] font-bold leading-none tracking-tight">500</strong><span className="text-base font-semibold">{t('unit')}</span></p>
        <p className="mt-2 text-xs">{t('newUsersOnly')}</p>
      </div>
      <CircleDollarSign className="h-16 w-16 shrink-0 text-white" strokeWidth={1.5} aria-hidden />
    </div>
  );
}
